import { Rv }        from '../../components'
import { PROJECTS }  from '../../constants/data'
import { FlipCard }  from './FlipCard'

export function ProjectsSection() {
  return (
    <section id="projects" className="sec">
      <div className="wrap">
        <Rv className="sh"><div className="slb">Personal Projects · GitHub</div><h2 className="st">Built Outside the Day Job</h2><div className="gbar"/><p className="ss">Click any card to reveal full details.</p></Rv>
        <div className="pg">
          {PROJECTS.map((p, i) => <FlipCard key={p.id} p={p} delay={(i % 3) * 0.1}/>)}
        </div>
      </div>
    </section>
  )
}
